import { AllowedDetailsTabEnum } from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                                from '@core/interfaces/route.interface';


export enum ArchivingRoutesEnum {
	ListPage = '',
	ImportsDetailPageTab = ':importId/:tab',
	ArchivingExportsDetailPage = ':archivingExportId/:tab',
	ArchivingExportItemsDetailPage = ':archivingExportId/:tab/:exportItemId',
	ArchivingProceduralDocumentationsDetailPage = ':archivingProceduralDocumentationId/:tab',
	ArchivingProceduralDocumentsDetailPage = ':archivingProceduralDocumentationId/:tab/:archivingProceduralDocumentId',
	ArchivingProceduralDocumentationExportsDetailPage = ':archivingProceduralDocumentationExportId/:tab',
	ArchivingProceduralDocumentationExportItemsDetailPage = ':archivingProceduralDocumentationExportId/:tab/:exportItemId',
	ArchivingTssLogDetailPage = ':archivingTssLogId',
	ArchivingTssLogExportsDetailPage = ':archivingTssLogExportId/:tab',
	ArchivingTssLogExportItemsDetailPage = ':archivingTssLogExportId/:tab/:exportItemId',
	CashPointClosingDetailPageTab = ':importId/:tab/:cashPointClosingId',
	OpenArchiveDetailPage = ':openArchiveId',
	OpenArchiveFormPageUpdate = ':openArchiveId/update',
	OpenArchiveExportDetailPage = ':openArchiveExportId/:tab',
	OpenArchiveExportItemsDetailPage = ':openArchiveExportId/:tab/:exportItemId',
}


export interface ArchivingImportsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingImports;

	path: ArchivingRoutesEnum.ImportsDetailPageTab;

	params: {
		importId: string;
		tab: AllowedDetailsTabEnum;
	};
}

export interface ArchivingTssLogDetailPage extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingTssLogs;

	path: ArchivingRoutesEnum.ArchivingTssLogDetailPage;

	params: {
		archivingTssLogId: string;
	};
}

export interface CashPointClosingDetailPageTab extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingImports;

	path: ArchivingRoutesEnum.CashPointClosingDetailPageTab;

	params: {
		importId: string;
		tab: AllowedDetailsTabEnum.CASH_POINT_CLOSING;
		cashPointClosingId: string;
	};
}

export interface ArchivingExportsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingExports;

	path: ArchivingRoutesEnum.ArchivingExportsDetailPage;

	params: {
		archivingExportId: string;
		tab: AllowedDetailsTabEnum;
	};
}

export interface ArchivingExportItemsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingExports;

	path: ArchivingRoutesEnum.ArchivingExportItemsDetailPage;

	params: {
		archivingExportId: string;
		tab: AllowedDetailsTabEnum.ARCHIVING_EXPORT_ITEMS;
		exportItemId: string;
	};
}

export interface ArchivingTssLogExportsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingTssLogExports;

	path: ArchivingRoutesEnum.ArchivingTssLogExportsDetailPage;

	params: {
		archivingTssLogExportId: string;
		tab: AllowedDetailsTabEnum;
	};
}

export interface ArchivingTssLogExportItemsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingTssLogExports;

	path: ArchivingRoutesEnum.ArchivingTssLogExportItemsDetailPage;

	params: {
		archivingTssLogExportId: string;
		tab: AllowedDetailsTabEnum.ARCHIVING_EXPORT_ITEMS;
		exportItemId: string;
	};
}

export interface ArchivingProceduralDocumentationsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingProceduralDocumentations;

	path: ArchivingRoutesEnum.ArchivingProceduralDocumentationsDetailPage;

	params: {
		archivingProceduralDocumentationId: string;
		tab: AllowedDetailsTabEnum;
	};
}

export interface ArchivingProceduralDocumentsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingProceduralDocumentations;

	path: ArchivingRoutesEnum.ArchivingProceduralDocumentsDetailPage;

	params: {
		archivingProceduralDocumentationId: string;
		tab: AllowedDetailsTabEnum.ARCHIVING_DOCUMENT;
		archivingProceduralDocumentId: string;
	};
}

export interface ArchivingProceduralDocumentationExportsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingProceduralDocumentationExports;

	path: ArchivingRoutesEnum.ArchivingProceduralDocumentationExportsDetailPage;

	params: {
		archivingProceduralDocumentationExportId: string;
		tab: AllowedDetailsTabEnum;
	};
}

export interface ArchivingProceduralDocumentationExportItemsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.ArchivingProceduralDocumentationExports;

	path: ArchivingRoutesEnum.ArchivingProceduralDocumentationExportItemsDetailPage;

	params: {
		archivingProceduralDocumentationExportId: string;
		tab: AllowedDetailsTabEnum.ARCHIVING_EXPORT_ITEMS;
		exportItemId: string;
	};
}

export interface OpenArchiveDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.OpenArchive;

	path: ArchivingRoutesEnum.OpenArchiveDetailPage;

	params: {
		openArchiveId: string;
	};
}

export interface OpenArchiveFormPageUpdateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.OpenArchive;

	path: ArchivingRoutesEnum.OpenArchiveFormPageUpdate;

	params: {
		openArchiveId: string;
	};
}

export interface OpenArchiveExportDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.OpenArchiveExport;

	path: ArchivingRoutesEnum.OpenArchiveExportDetailPage;

	params: {
		openArchiveExportId: string;
		tab: AllowedDetailsTabEnum;
	};
}


export interface OpenArchiveExportItemsDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.OpenArchiveExport;

	path: ArchivingRoutesEnum.OpenArchiveExportItemsDetailPage;

	params: {
		openArchiveExportId: string;
		tab: AllowedDetailsTabEnum.ARCHIVING_EXPORT_ITEMS;
		exportItemId: string;
	};
}
